/* Maps a notification's semantic severity onto Stencil icons and design tokens. */
import IconAlertTriangleFillMedium from '@amzn/stencil-react-icons/icons/icon-alert-triangle-fill-medium';
import IconCheckCircleFillMedium from '@amzn/stencil-react-icons/icons/icon-check-circle-fill-medium';
import IconClockFillMedium from '@amzn/stencil-react-icons/icons/icon-clock-fill-medium';
import IconCloseCircleFillMedium from '@amzn/stencil-react-icons/icons/icon-close-circle-fill-medium';
import { NotificationSeverity } from './notificationPresentation';

export interface SeverityStencilPresentation {
  Icon: typeof IconCheckCircleFillMedium;
  iconColor: string;
}

// Semantic status tokens rather than palette values, so they follow the theme. Shape carries the
// same information as the color, for anyone who cannot distinguish the hues.
const SEVERITY_PRESENTATION: Record<NotificationSeverity, SeverityStencilPresentation> = {
  success: { Icon: IconCheckCircleFillMedium, iconColor: 'color.status.success-icon' },
  critical: { Icon: IconCloseCircleFillMedium, iconColor: 'color.status.critical-icon' },
  pending: { Icon: IconClockFillMedium, iconColor: 'color.status.info-icon' },
  unknown: { Icon: IconAlertTriangleFillMedium, iconColor: 'color.status.warning-icon' }
};

export const getSeverityStencilPresentation = (severity: NotificationSeverity): SeverityStencilPresentation =>
  SEVERITY_PRESENTATION[severity];
